<template>
    <article>
        <PageIntro>
            <template #title>
                {{ data?.entry?.title }}
            </template>
            <template #intro>
                {{ data?.entry?.intro }}
            </template>
        </PageIntro>

        <StoryList :active-filter="activeFilter">
            <template #filters>
                <BaseFilters
                    :items="data?.entries"
                    :active-filters="[activeFilter]"
                    :pending="pending"
                >
                    <template #all-filters-wrapper>
                        <BaseDotLink
                            :active="!activeFilter?.length"
                            @click="clearFilters"
                        >
                            {{ $t('all-stories') }}
                        </BaseDotLink>
                    </template>

                    <template
                        v-for="(item, index) in data?.entries"
                        #[`filter-${index}`]
                        :key="index"
                    >
                        <BaseDotLink
                            :active="activeFilter === item.slug"
                            @click="toggleFilter(item.slug)"
                        >
                            {{ item.title }}
                        </BaseDotLink>
                    </template>
                </BaseFilters>
            </template>
        </StoryList>

        <NewsletterBlock
            v-if="data?.entry?.newsletterBlock?.[0] || pending"
            :image="data?.entry?.newsletterBlock?.[0].image?.[0]"
            :pending="pending"
            :background-color="data?.entry?.newsletterBlock?.[0]?.backgroundColor"
            :list-id="data?.entry?.newsletterBlock?.[0]?.listId ?? undefined"
            :consent-id="data?.entry?.newsletterBlock?.[0]?.consentId ?? undefined"
        >
            <template
                v-if="data?.entry?.newsletterBlock?.[0]?.title"
                #title
            >
                {{ data.entry.newsletterBlock[0].title }}
            </template>

            <template
                v-if="data?.entry?.newsletterBlock?.[0]?.description"
                #description
            >
                {{ data.entry.newsletterBlock[0].description }}
            </template>
        </NewsletterBlock>
    </article>
</template>

<script setup>
import StoriesQuery from '~/graphql/queries/stories.graphql';

const route = useRoute();
const router = useRouter();

const { variables } = useCraftGraphql();
delete variables.uri;

const response = await useLazyAsyncQuery({
    query: StoriesQuery,
    variables
});

const pending = response.pending;
const data = response.data;

const activeFilter = ref(null);

const toggleFilter = (filter) => {
    activeFilter.value === filter ? activeFilter.value = null : activeFilter.value = filter;
};

watch(() => route.query, () => {
    if (route.query.category) {
        activeFilter.value = route.query.category;
    } else {
        activeFilter.value = null;
    }
}, { immediate: true });

const clearFilters = () => {
    activeFilter.value = null;
};

watch(
    () => activeFilter,
    () => {
        if (!activeFilter.value?.length) {
            router.push({
                query: {}
            });
            return;
        }

        router.push({
            query: {
                category: activeFilter.value
            }
        });
    }, {
        deep: true
    }
);
</script>
